import React, { useEffect, useState } from "react";
import * as Icon from "react-icons/fi";
import Checkbox from "react-custom-checkbox";
import { Tooltip, Select, Form } from "antd";

import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import events from "./event";

import "react-big-calendar/lib/css/react-big-calendar.css";

import RightBar from "../../components/common/RightBar";
import ConfirmationBox from "../../components/common/ConfirmationBox";

import "./CalendarPage.css";

import RightBarMethod from "../../components/common/RightBar/RightBarMethod";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../firebase";
import { collection, doc, getDocs, query, where } from "firebase/firestore";

const CalendarRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Sync To Google Calendar", "1", "", "", ""),
  ]),
];

function CalendarPage() {
  const [user, loading] = useAuthState(auth);

  const [companyName, setCompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const [activites, setActivites] = useState(null);
  const [allData, setAllData] = useState(null);
  const [properties, setProperties] = useState([]);
  const [allUsers, setAllUsers] = useState([]);

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
      setIsCompanyNameFetched(true);
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const fetchProperties = async () => {
    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, companyName);
    const propertiesRef = collection(companyDocRef, "properties");
    try {
      const querySnapshot = await getDocs(propertiesRef);
      const propertiesData = querySnapshot.docs.map((d) => ({
        ...d.data(),
        id: d.id,
      }));

      setProperties(propertiesData);
    } catch (error) {
      console.error("Error fetching properties:", error);
    }
  };

  const fetchUsers = async () => {
    const usersRef = collection(db, "allUsers");
    try {
      const querySnapshot = await getDocs(usersRef);
      const usersData = querySnapshot.docs.map((d) => ({
        ...d.data(),
        id: d.id,
      }));

      setAllUsers(usersData);
    } catch (error) {
      console.error("Error fetching properties:", error);
    }
  };

  function getRandomColor() {
    const colors = ["blue", "SeaGreen", "SteelBlue"];
    const randomIndex = Math.floor(Math.random() * colors.length);
    return colors[randomIndex];
  }

  const fetchActivities = async () => {
    try {
      const userRef = collection(db, "companies", companyName, "activities");
      const snapshot = await getDocs(userRef);
      const fetchedData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setAllData(fetchedData);

      let allTransformedData = [];
      fetchedData.forEach((item) => {
        if (Array.isArray(item.propertiesActivities)) {
          let filteredActivities = item.propertiesActivities.filter(
            (activity) => activity.assignTo === user?.uid
          );

          let transformedData = filteredActivities.map((item, index) => {
            return {
              id: index,
              title: item.Description,
              allDay: item.allDay,
              start: new Date(item.activityDate), // create a Date object with DD-MM-YYYY format
              end: new Date(item.activityDate), // create a Date object with DD-MM-YYYY format
              hexColor: getRandomColor(),
            };
          });
          allTransformedData.push(...transformedData);
        } else {
          console.log("propertiesActivities is not an array");
        }
      });
      setActivites(allTransformedData);
    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };
  useEffect(() => {
    if (!isCompanyNameFetched) return;

    fetchActivities();
    fetchProperties();
    fetchUsers();
  }, [companyName, isCompanyNameFetched]);

  const propSearch = properties.map((p) => ({
    value: `${p.id} `,
    label: `${p.propertyNameAddress.propertyName}`,
  }));
  const userSearch = allUsers.map((u) => ({
    value: `${u.id} `,
    label: `${u.firstName} ${u.lastName} <${u.email}>`,
  }));

  const CustomToolbar = (toolbar) => {
    const goToBack = () => {
      toolbar.onNavigate("PREV");
    };
    const goToNext = () => {
      toolbar.onNavigate("NEXT");
    };
    const goToCurrent = () => {
      toolbar.onNavigate("TODAY");
    };

    const goToDayView = () => {
      toolbar.onView("day");
    };
    const goToWeekView = () => {
      toolbar.onView("week");
    };
    const goToMonthView = () => {
      toolbar.onView("month");
    };
    const goToAgendaView = () => {
      toolbar.onView("agenda");
    };

    const label = toolbar.label;

    return (
      <div className="rbc-toolbar">
        <span className="rbc-btn-group">
          <span className="rbc-btn-group">
            <button onClick={goToBack} aria-label="prev">
              <span className=" fa fa-chevron-left" />
            </button>
            <button onClick={goToNext} aria-label="next">
              <span className=" fa fa-chevron-right" />
            </button>
            <button onClick={goToCurrent} className="todayBtn">
              <span>Today</span>
            </button>
          </span>
        </span>
        <span className="rbc-toolbar-label">{label}</span>
        <span className="rbc-btn-group">
          <button onClick={goToMonthView}>Month</button>
          <button onClick={goToWeekView}>Week</button>
          <button onClick={goToDayView}>Day</button>
          <button onClick={goToAgendaView}>Agenda</button>
        </span>
      </div>
    );
  };

  const localizer = momentLocalizer(moment);
  const eventStyleGetter = (activites) => {
    var backgroundColor = activites.hexColor;
    var style = {
      backgroundColor: backgroundColor,
      borderRadius: "0px",
      color: "#fff",
      border: "0px",
      display: "block",
      marginBottom: "10px",
    };
    return {
      style: style,
    };
  };
  const [isConfirmationBoxOpen, setIsConfirmationBoxOpen] = useState(false);

  const CustomEvent = (activites) => {
    return (
      <Tooltip
        placement="bottom"
        title={
          <span style={{ color: "#001529" }}>
            Title: <a href="/">{activites?.title}</a>
          </span>
        }
        trigger={["click"]}
        color={["#fff"]}
      >
        <p className="eventTitle">{activites?.title}</p>
      </Tooltip>
    );
  };

  const handleCustomize = () => {
    setIsConfirmationBoxOpen(true);
  };

  const onChange = (value) => {
    console.log(`selected ${value}`);
  };
  const onSearch = (value) => {
    console.log("search:", value);
  };
  const [form] = Form.useForm();

  return (
    <div className="calenderPage">
      <div className="page-container">
        <div className="main-container">
          <div className="pageheading">
            <h1>Calendar</h1>
            {/* <div className="filterNbtn">
              <button
                className="calendarCustomizeBtn"
                onClick={handleCustomize}
              >
                Customize
              </button>
            </div> */}
          </div>
          <p>
            <b>Event Types: </b> All
          </p>
          {/* Footer  */}
          <Calendar
            localizer={localizer}
            defaultDate={new Date()}
            events={activites?.length > 0 ? activites : []}
            className="bigCalenger"
            components={{
              toolbar: CustomToolbar,
              event: CustomEvent,
            }}
            views={{
              week: true,
              month: true,
              day: true,
              agenda: true,
            }}
            eventPropGetter={eventStyleGetter}
            // selected={selected}
            // onSelectEvent={handleSelected}
          />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={CalendarRightBar} />
      </div>

      {isConfirmationBoxOpen ? (
        <ConfirmationBox setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}>
          <h2>Customize Calendar</h2>
          <div className="message">
            <Form form={form} layout="vertical">
              <Form.Item label="Property">
                <Select
                  showSearch
                  allowClear
                  placeholder="Search by property, group, or portfolio"
                  optionFilterProp="children"
                  onChange={onChange}
                  onSearch={onSearch}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={propSearch}
                  name="propertyFilter"
                />
              </Form.Item>

              <Form.Item label="Assigned to">
                <Select
                  showSearch
                  allowClear
                  placeholder="Search by assignee"
                  optionFilterProp="children"
                  onChange={onChange}
                  onSearch={onSearch}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={userSearch}
                  name="propertyFilter"
                />
              </Form.Item>

              <Form.Item label="Event Types">
                <div className="checkBoxCalenderPagePopup">
                  <Checkbox
                    checked={true}
                    icon={
                      <div
                        style={{
                          display: "flex",
                          flex: 1,
                          backgroundColor: "#50b74e",
                          alignSelf: "stretch",
                        }}
                      >
                        <Icon.FiCheck
                          color="white"
                          size={20}
                          className="Kashif"
                        />
                      </div>
                    }
                    borderColor="#50b74e"
                    style={{ overflow: "hidden" }}
                    size={20}
                    label="Move Ins"
                  />
                </div>

                <div className="checkBoxCalenderPagePopup">
                  <Checkbox
                    checked={true}
                    icon={
                      <div
                        style={{
                          display: "flex",
                          flex: 1,
                          backgroundColor: "#c04e44",
                          alignSelf: "stretch",
                        }}
                      >
                        <Icon.FiCheck color="white" size={20} />
                      </div>
                    }
                    borderColor="#c04e44"
                    style={{ overflow: "hidden" }}
                    size={20}
                    label="Move Outs"
                  />
                </div>

                <div className="checkBoxCalenderPagePopup">
                  <Checkbox
                    checked={true}
                    icon={
                      <div
                        style={{
                          display: "flex",
                          flex: 1,
                          backgroundColor: "#f09b58",
                          alignSelf: "stretch",
                        }}
                      >
                        <Icon.FiCheck color="white" size={20} />
                      </div>
                    }
                    borderColor="#f09b58"
                    style={{ overflow: "hidden" }}
                    size={20}
                    label="Lease Ends"
                  />
                </div>
                <div className="checkBoxCalenderPagePopup">
                  <Checkbox
                    checked={true}
                    icon={
                      <div
                        style={{
                          display: "flex",
                          flex: 1,
                          backgroundColor: "#2ca5dc",
                          alignSelf: "stretch",
                        }}
                      >
                        <Icon.FiCheck color="white" size={20} />
                      </div>
                    }
                    borderColor="#2ca5dc"
                    style={{ overflow: "hidden" }}
                    size={20}
                    label="Pending Activities"
                  />
                </div>
                <div className="checkBoxCalenderPagePopup">
                  <Checkbox
                    checked={true}
                    icon={
                      <div
                        style={{
                          display: "flex",
                          flex: 1,
                          backgroundColor: "#b3b3b3",
                          alignSelf: "stretch",
                        }}
                      >
                        <Icon.FiCheck color="white" size={20} />
                      </div>
                    }
                    borderColor="#b3b3b3"
                    style={{ overflow: "hidden" }}
                    size={20}
                    label="Completed Activities"
                  />
                </div>

                <div className="checkBoxCalenderPagePopup">
                  <Checkbox
                    checked={true}
                    icon={
                      <div
                        style={{
                          display: "flex",
                          flex: 1,
                          backgroundColor: "#7b428a",
                          alignSelf: "stretch",
                        }}
                      >
                        <Icon.FiCheck color="white" size={20} />
                      </div>
                    }
                    borderColor="#7b428a"
                    style={{ overflow: "hidden" }}
                    size={20}
                    label="Showings"
                  />
                </div>
                <div className="checkBoxCalenderPagePopup">
                  <Checkbox
                    checked={true}
                    icon={
                      <div
                        style={{
                          display: "flex",
                          flex: 1,
                          backgroundColor: "#dec5ba",
                          alignSelf: "stretch",
                        }}
                      >
                        <Icon.FiCheck color="white" size={20} />
                      </div>
                    }
                    borderColor="#dec5ba"
                    style={{ overflow: "hidden" }}
                    size={20}
                    label="Work Orders"
                  />
                </div>
              </Form.Item>
              <Form.Item>
                <div style={{ marginTop: "10px" }}>
                  <Checkbox
                    checked={false}
                    icon={
                      <div
                        style={{
                          display: "flex",
                          flex: 1,
                          backgroundColor: "#1677ff",
                          alignSelf: "stretch",
                        }}
                      >
                        <Icon.FiCheck color="white" size={20} />
                      </div>
                    }
                    borderColor="#000"
                    style={{ overflow: "hidden" }}
                    size={20}
                    label="Set these as my default filters"
                  />
                </div>
              </Form.Item>
            </Form>
          </div>
          <div className="action-buttons">
            <button
              className="blue"
              onClick={() => setIsConfirmationBoxOpen(false)}
            >
              Saved
            </button>
            <button
              className="cancel-btn"
              onClick={() => setIsConfirmationBoxOpen(false)}
            >
              Cancel
            </button>
          </div>
        </ConfirmationBox>
      ) : null}
    </div>
  );
}

export default CalendarPage;
